import { render } from "./InterOral.vue?vue&type=template&id=5489002f&ts=true"
import script from "./InterOral.vue?vue&type=script&lang=ts"
export * from "./InterOral.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__